interface StallRecoveryWatchdogOptions {
	timeoutMs: number;
	maxRecoveryAttempts: number;
	onRecoverableStall: (attempt: number) => void;
	onFatalStall: (attempt: number) => void;
}

interface StallRecoveryWatchdog {
	/** Inicia a janela de vigilância (não zera o orçamento de tentativas). */
	arm: () => void;
	/**
	 * Reagenda a janela mantendo o orçamento de tentativas — usado após uma
	 * recuperação/reconexão, onde ainda não houve progresso real do cálculo.
	 * Assim a próxima parada consecutiva escala para fatal.
	 */
	rearm: () => void;
	/**
	 * Sinaliza atividade REAL do cálculo (progress/result/error). Zera o
	 * orçamento de tentativas e reagenda — o ciclo de "paradas consecutivas"
	 * recomeça do zero quando o cálculo dá sinal de vida.
	 */
	noteActivity: () => void;
	clear: () => void;
}

export function createStallRecoveryWatchdog(
	options: StallRecoveryWatchdogOptions,
): StallRecoveryWatchdog {
	let timer: ReturnType<typeof setTimeout> | null = null;
	let stallCount = 0;

	const clear = () => {
		if (!timer) {
			return;
		}

		clearTimeout(timer);
		timer = null;
	};

	const schedule = () => {
		clear();
		timer = setTimeout(() => {
			stallCount += 1;

			if (stallCount <= options.maxRecoveryAttempts) {
				options.onRecoverableStall(stallCount);
				return;
			}

			options.onFatalStall(stallCount);
		}, options.timeoutMs);
	};

	const noteActivity = () => {
		stallCount = 0;
		schedule();
	};

	return {
		arm: schedule,
		rearm: schedule,
		noteActivity,
		clear,
	};
}
